module.exports = __webpack_public_path__ + "static/media/theme-landing-2-item-1.c01f02d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/theme-landing-2-item-1.png
// module id = 366
// module chunks = 0